import { makeStyles } from '@material-ui/core/styles';
import { Filter, Plus } from 'react-feather';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    height: '25px',
  },
  plus: {
    height: '60%',
    position: 'absolute',
    bottom: 0,
    left: '60%',
  },
});

type Props = {
  strokeWidth?: string;
  color?: string;
  style?: React.CSSProperties;
};

const FilterIcon = ({ strokeWidth, color, style }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.root} style={style}>
      <Filter strokeWidth={strokeWidth} color={color} />
      <Plus className={classes.plus} strokeWidth={strokeWidth} color={color} />
    </div>
  );
};

export default FilterIcon;
